import { LayoutGallery } from '@wix/wix-ui-icons-common';
import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../../ricos-context';
import { getIsModalOpen, useModalState } from './../../../ricos-modals/modal-service-provider';
import { GalleryOptions_Layout_Type } from './../../../ricos-schema/next-schema';
import type { IToolbarItem } from './../../../ricos-types';
import type { SupportedLayouts } from './../../common-types';
import { DropdownButton } from './../../../toolbars-ui';

import { GALLERY_LAYOUT_DROPDOWN, GALLERY_LAYOUT_SETTINGS_MODAL } from '../../consts';
import { dropdownOptions } from '../LayoutDropdown';

type Props = {
  toolbarItem: IToolbarItem;
  dataHook?: string;
};

export const GalleryLayoutButton: FC<Props> = ({ dataHook, toolbarItem }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(GALLERY_LAYOUT_SETTINGS_MODAL));
  const isDropdownOpen = useModalState(getIsModalOpen(GALLERY_LAYOUT_DROPDOWN));

  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);

  const selectedLayout =
    dropdownOptions[toolbarItem?.attributes.layout as SupportedLayouts] ||
    dropdownOptions[GalleryOptions_Layout_Type.GRID];

  return (
    <DropdownButton
      dataHook={dataHook}
      active={isDropdownOpen || isModalOpen}
      onClick={e =>
        toolbarItem.commands?.click({ referenceElement, isMobile, clickFromKeyboard: !e.detail })
      }
      setRef={setReferenceElement}
      Icon={(selectedLayout.icon as (props?: any) => JSX.Element) || LayoutGallery}
      label={t(selectedLayout?.text || 'GalleryPlugin_Layout_Grid')}
      tooltip={t('GalleryPlugin_Layout_Select_Tooltip')}
    />
  );
};
